<script lang="ts">import { afterNavigate, beforeNavigate, onNavigate, replaceState } from "$app/navigation";
import { page } from "$app/stores";
import { Currency, Language, StartBetbySession } from "./api/api";
import { appMode, cfgBetbyBrandId, cfgBetbyThemeName, stateUi, wantThemes } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { Footer } from "@infinitro/footer";
import { Api, betbyCurrentRoute, layoutRightOffset as betSlipOffsetRight, getSubject, hasSportsLoaded, isBetbyDisplayed, isMobile, locale, loggedIn, ModalDialog, pushModal, setIsCollapsedFomoBets, stateBetbyPage, stateOpenModal, toObservable, toSiteUrl, UI } from "@infinitro/global";
import { walletStore } from "@infinitro/global/wallet";
import { SportsSeoText } from "@infinitro/seo-text";
import { jwtDecode } from "jwt-decode";
import { combineLatest, filter, map, of, retry, switchMap, tap, throwError } from "rxjs";
import { onMount } from "svelte";
import { get } from "svelte/store";
import { modifyCSSRuleMultiple } from "./utils/util";
const betslipBarCustomize$ = getSubject();
const stateUiSetting = $stateUi;
const isSportsUrl = (path) => /\/sports(\/|$)/.test(path);
// Betby paths are relative to the sports basename (e.g. '/soccer-1/matches').
const extractBetbySportSlug = (betbyPath) => {
	if (!betbyPath || betbyPath === "/") return "sports";
	const firstSegment = betbyPath.split("/").filter(Boolean)[0];
	return firstSegment || "sports";
};
const extractSportsPathnameSlug = (pathname) => {
	const parts = pathname.split("/").filter(Boolean);
	const sportsIndex = parts.indexOf("sports");
	if (sportsIndex < 0) return "";
	return parts[sportsIndex + 1] || "sports";
};
let _previousBetbySportSlug = undefined;
let _previousSportsUrlSlug = undefined;
const isConcreteSportSlug = (slug) => slug !== "" && slug !== "sports";
const shouldScrollOnSportChange = (previousSlug, nextSlug) => previousSlug !== undefined && isConcreteSportSlug(previousSlug) && isConcreteSportSlug(nextSlug) && nextSlug !== previousSlug;
const scrollSportsToTop = () => {
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: "auto"
	});
	document.documentElement.scrollTop = 0;
	document.body.scrollTop = 0;
	const innerPage = document.querySelector(".innerpage");
	innerPage?.scrollTo({
		top: 0,
		left: 0,
		behavior: "auto"
	});
	const betbyContent = document.getElementById("betby-content");
	betbyContent?.scrollTo({
		top: 0,
		left: 0,
		behavior: "auto"
	});
};
const scrollSportsToTopSync = () => {
	scrollSportsToTop();
	requestAnimationFrame(scrollSportsToTop);
};
const onPopState = () => {
	const currentPath = window.location.pathname;
	isBetbyDisplayed.set(isSportsUrl(currentPath));
	console.log(`betby onPopState page is ${currentPath}`);
	if (isSportsUrl(currentPath)) {
		const sportSlug = extractSportsPathnameSlug(currentPath);
		const shouldScrollToTop = shouldScrollOnSportChange(_previousSportsUrlSlug, sportSlug);
		_previousSportsUrlSlug = sportSlug;
		_previousBetbySportSlug = sportSlug;
		if (shouldScrollToTop) {
			scrollSportsToTopSync();
		}
	}
};
afterNavigate((page) => {
	console.log(`betby afterNavigate`, page);
	if (!/\/sports(\/|$)/.test(page.to?.url.pathname ?? "")) {
		setIsCollapsedFomoBets(false);
	}
});
onNavigate((page) => {
	console.log(`betby onNavigate`, page);
	if (!page?.to?.route?.id) return;
	isBetbyDisplayed.set(/\/sports(\/|$)/.test(page.to.route.id));
});
beforeNavigate((page) => {
	console.log(`betby beforeNavigate`, page);
});
const brand_id = cfgBetbyBrandId();
const themeName = cfgBetbyThemeName();
let betbyContainer = null;
// @ts-expect-error('BTRenderer is defined')
let _betbyRenderLib = null;
const headerHeight = 72;
const mobileFooterHeight = stateUiSetting.betby.betslipBottom;
let betSlipOffsetBottom = $isMobile ? mobileFooterHeight : 0;
const betslipZIndex = 999;
const getHeaderOffsetTop = () => headerHeight;
const updateBetbyMobileTop = (offsetTop) => {
	if (!betbyContainer) return;
	const topOffset = Math.max(offsetTop ?? getHeaderOffsetTop(), 0);
	betbyContainer.style.setProperty("--betby-mobile-top", `${topOffset || headerHeight}px`);
};
export const sleep = (ms = 0) => new Promise((resolve) => setTimeout(resolve, ms));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _betbyRenderer = undefined;
let _isBetbyDisplayed = undefined;
let lang = $locale.toUpperCase();
let currentLoggedIn = $loggedIn;
let basename = toSiteUrl("/sports", currentLoggedIn).slice(0, -1);
let _betbyToken = undefined;
let _loggedIn = undefined;
let _betbySessionId = undefined;
let _betbyPlayerCurrency = undefined;
let _betbyAccountNum = undefined;
let _killed = true;
const killSession = async () => {
	if (_betbyRenderer) {
		try {
			_betbyRenderer.kill();
		} catch {
			console.log(`error killing betby renderer`);
		} finally {
			_betbyRenderer = undefined;
		}
	}
	_killed = true;
	_betbyInitialized = false;
};
const reinitialize = async () => {
	if (!_killed || _betbyRenderer) {
		await killSession();
	}
	await initialize();
};
walletStore.subscribe(async (wallet) => {
	if (!wallet) return;
	if (_betbyAccountNum === wallet.accountNum) return;
	if (_betbyAccountNum && _betbyAccountNum !== wallet.accountNum) {
		if (_isBetbyDisplayed) {
			console.log(`betby account number changed`, _betbyAccountNum, wallet.accountNum);
			await reinitialize();
		}
	}
});
function isTokenExpired(token) {
	try {
		const decoded = jwtDecode(token);
		console.log(`token expires at ${decoded.exp} vs ${Date.now()}`);
		return false;
	} catch (e) {
		console.log(e);
	}
	return false;
}
let _gettingToken = null;
export async function getToken() {
	if (_gettingToken) {
		console.log(`betby already getting token ${Date.now() - _gettingToken}ms ago`);
		return;
	}
	_gettingToken = Date.now();
	let token;
	try {
		_betbyPlayerCurrency = $walletStore?.currency;
		_betbyAccountNum = $walletStore?.accountNum;
		_betbySessionId = undefined;
		const variables = { params: {
			betbySessionId: null,
			language: lang.toUpperCase(),
			playerCurrency: _betbyPlayerCurrency,
			accountNum: _betbyAccountNum
		} };
		console.log(`getting betby session token`, variables);
		const betbySession = await StartBetbySession({
			variables,
			context: { api: Api.player }
		});
		token = betbySession?.data?.startBetbySession?.token;
		if (token) {
			_betbyToken = token;
			_betbySessionId = betbySession?.data?.startBetbySession?.betbySessionId;
			console.log(jwtDecode(token));
		} else {
			console.log(`no betby token`);
		}
	} catch (e) {
		console.log(`error getting token`, e);
	} finally {
		_gettingToken = null;
	}
	return token;
}
isBetbyDisplayed.subscribe(async (displayed) => {
	if (displayed === undefined || _isBetbyDisplayed === displayed) return;
	if (_isBetbyDisplayed === true && displayed === false) {
		_isBetbyDisplayed = false;
		await killSession();
	} else if (displayed === true) {
		_isBetbyDisplayed = true;
		hasSportsLoaded.set(true);
		await initialize();
	}
});
locale.subscribe(async (_lang) => {
	lang = _lang.toLowerCase();
	basename = toSiteUrl("/sports", currentLoggedIn).slice(0, -1);
	if (_isBetbyDisplayed) {
		await reinitialize();
	}
});
isMobile.subscribe((mobile) => {
	betSlipOffsetBottom = mobile ? mobileFooterHeight : 0;
	if (_betbyRenderer && _isBetbyDisplayed) {
		_betbyRenderer.updateOptions({ betSlipOffsetBottom });
	}
});
stateBetbyPage.subscribe((page) => {
	if (_betbyRenderer && _isBetbyDisplayed && !page.includes(appMode)) {
		_betbyRenderer.updateOptions({ url: page });
	}
});
betSlipOffsetRight.subscribe((offset) => {
	if (_betbyRenderer && _isBetbyDisplayed) {
		_betbyRenderer.updateOptions({ betSlipOffsetRight: offset === 0 && !$isMobile ? 15 : offset });
	}
});
loggedIn.subscribe(async (loggedIn) => {
	if (_loggedIn === loggedIn) return;
	_loggedIn = loggedIn;
	currentLoggedIn = loggedIn;
	basename = toSiteUrl("/sports", currentLoggedIn).slice(0, -1);
	if (loggedIn === true) {
		if (_isBetbyDisplayed) await reinitialize();
	} else if (loggedIn === false) {
		_betbyToken = null;
		_betbySessionId = undefined;
		_betbyPlayerCurrency = undefined;
		_betbyAccountNum = undefined;
		if (_isBetbyDisplayed) await reinitialize();
	}
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onBannerClick = (...args) => {
	console.log(`onBannerClick`);
	console.log(args);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onBetSlipStateChange = (...args) => {
	console.log(`onBetSlipStateChange`);
	const info = args[0];
	if (info) {
		if (info.isOpen) {
			setIsCollapsedFomoBets(true);
		} else {
			setIsCollapsedFomoBets(false);
			betslipBarCustomize$.next(true);
		}
	}
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onLogin = (...args) => {
	console.log(`onLogin`);
	console.log(args);
	pushModal(ModalDialog.Auth, { tab: "login" });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onOutcomeClick = (...args) => {
	console.log(`onOutcomeClick`);
	console.log(args);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onRecharge = (...args) => {
	console.log(`onRecharge`);
	console.log(args);
	pushModal(ModalDialog.Cashier);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onRegister = (...args) => {
	console.log(`onRegister`);
	console.log(args);
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onRouteChange = (betbyPath) => {
	const currentPath = get(page).url.pathname;
	console.log(`betby onRouteChange: ${betbyPath} at ${currentPath}`);
	betbyCurrentRoute.set(betbyPath);
	// Sync $page.url so that URL-driven bindings (e.g. SportsSeoText) stay live
	// without a full SvelteKit navigation. replaceState updates $page.url.pathname
	// in place, matching the static shell's URL convention.
	replaceState(toSiteUrl(`/sports${betbyPath}`, get(loggedIn)), {});
	// Internal BetBy navigation must not kill the renderer when SvelteKit URL is still non-sports
	// (e.g. client navigated from / to /sports/ before pathname was synced).
	if (isSportsUrl(currentPath) || _isBetbyDisplayed || _betbyRenderer) {
		isBetbyDisplayed.set(true);
	} else {
		isBetbyDisplayed.set(false);
	}
	const sportSlug = extractBetbySportSlug(betbyPath);
	const shouldScrollToTop = shouldScrollOnSportChange(_previousBetbySportSlug, sportSlug);
	_previousBetbySportSlug = sportSlug;
	_previousSportsUrlSlug = sportSlug;
	if (shouldScrollToTop) {
		scrollSportsToTopSync();
	}
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onSessionRefresh = async (...args) => {
	console.log(`onSessionRefresh`, args);
	_betbySessionId = undefined;
	await reinitialize();
	return _betbyToken;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onTokenExpired = async (...args) => {
	console.log(`onTokenExpired`, args);
	_betbySessionId = undefined;
	const token = await getToken();
	if (!token) {
		await reinitialize();
	}
	return token;
};
let _betbyInitializing = null;
let _betbyInitialized = false;
const initialize = async () => {
	if (_betbyInitializing) {
		console.log(`betby already initializing ${Date.now() - _betbyInitializing}ms ago`);
		return;
	}
	_betbyInitializing = Date.now();
	let token = undefined;
	try {
		if (!_betbyRenderLib) {
			await performRendererInitialization();
		}
		while (_loggedIn === undefined) {
			await sleep(200);
		}
		await sleep(300);
		if (_loggedIn) {
			token = await getToken();
		}
		const headerOffsetTop = getHeaderOffsetTop();
		updateBetbyMobileTop(headerOffsetTop);
		const vars = {
			basename,
			betSlipOffsetTop: headerOffsetTop,
			betSlipOffsetRight: $betSlipOffsetRight === 0 && !$isMobile ? 15 : $betSlipOffsetRight,
			betSlipOffsetBottom,
			betslipZIndex,
			stickyTop: headerOffsetTop,
			brand_id,
			lang,
			onBannerClick,
			onBetSlipStateChange,
			onLogin,
			onOutcomeClick,
			onRecharge,
			onRegister,
			onRouteChange,
			onSessionRefresh,
			onTokenExpired,
			target: document.getElementById("betby-content"),
			themeName,
			token
		};
		console.log(`betby initializing with`, vars);
		_betbyRenderer = _betbyRenderLib.initialize(vars);
		_killed = false;
		_betbyInitialized = true;
		betslipBarCustomize$.next(true);
	} catch (e) {
		console.log(`betby initialization error: ${e}`);
	} finally {
		_betbyInitializing = null;
	}
};
const patchSession = async () => {
	// deprecated, they complain you can duplicate sessions and achieve a wallet mismatch
	if (!_betbyToken || !_betbySessionId || !_betbyInitialized) return initialize();
	await getToken();
};
async function performRendererInitialization() {
	try {
		let seconds = 0;
		// @ts-expect-error('BTRenderer is defined')
		while (typeof BTRenderer === "undefined") {
			console.log(`waiting ${seconds++} seconds for BTRenderer to load`);
			await sleep(1e3);
		}
		// @ts-expect-error('BTRenderer is defined')
		_betbyRenderLib = new BTRenderer();
		console.log(`betby render lib initialized`);
	} catch (e) {
		console.log(`btrenderer error: ${e}`);
	}
}
// ＝＝＝for modify the betby inside UI＝＝＝＝＝＝＝＝＝
const isCustomUI$ = toObservable(isMobile).pipe(map((isMobile) => isMobile && stateUiSetting.betby.customUI));
const betbyShadowRoot$ = of(true).pipe(switchMap(() => {
	const shadowRoot = Array.from(document.querySelector("#betby>div")?.children ?? []).filter((elem) => !!elem.shadowRoot).map((elem) => elem.shadowRoot)[0];
	if (shadowRoot) {
		return of(shadowRoot);
	}
	throw new Error("not ready");
}));
const isBetslipOpen$ = of(true).pipe(switchMap(() => betbyShadowRoot$), switchMap((shadowRoot) => {
	const contentElem = shadowRoot?.querySelector("[data-editor-id=betslipContent]");
	if (!contentElem) {
		throw new Error("not ready");
	}
	const iconElem = shadowRoot.querySelector("[data-editor-id=betslipMobileButtonGradient],[data-editor-id=quickBetMobileButtonGradient]");
	if (iconElem) {
		return of(false);
	}
	return of(true);
}), retry({
	count: 180,
	delay: 100
}));
const betbyElemsInfo$ = of(true).pipe(switchMap(() => betbyShadowRoot$), switchMap((shadowRoot) => {
	const iconElem = shadowRoot.querySelector("[data-editor-id=betslipMobileButtonGradient],[data-editor-id=quickBetMobileButtonGradient]");
	if (!iconElem) {
		throw new Error("not ready");
	}
	const contentElem = shadowRoot.querySelector("[data-editor-id=betslipContent]");
	const totalElem = iconElem.querySelector("#bt-header-total");
	const iconElemWrap = iconElem.parentElement;
	const iconElemAttr = iconElem.dataset.editorId;
	if (iconElem && contentElem && totalElem) {
		const info = {
			shadowRoot,
			iconElemWrap,
			iconElem,
			contentElem,
			totalElem
		};
		if (iconElemAttr === "betslipMobileButtonGradient") {
			let iconSvgElem = iconElem.querySelector("svg[data-cy=ic-betslip]");
			if (!iconSvgElem) {
				return throwError(() => new Error("not ready"));
			}
			return of({
				...info,
				iconSvgElem
			});
		} else {
			return of({
				...info,
				iconSvgElem: null
			});
		}
	}
	throw new Error("not ready");
}), retry({
	count: 180,
	delay: 100
}));
// -----
const betslipStateSub = betslipBarCustomize$.pipe(switchMap(() => isCustomUI$), filter((isCustomUI) => isCustomUI), switchMap(() => isBetslipOpen$), tap((isBetslipOpen) => {
	setIsCollapsedFomoBets(isBetslipOpen);
})).subscribe();
// everytime
const betslipBarCustomizeSub = betslipBarCustomize$.pipe(switchMap(() => isCustomUI$), filter((isCustomUI) => isCustomUI), switchMap(() => combineLatest([toObservable(locale), betbyElemsInfo$])), tap(([lang, info]) => {
	const iconElemWrapClassName = info.iconElemWrap?.classList[0];
	if (iconElemWrapClassName) {
		modifyCSSRuleMultiple(info.shadowRoot, iconElemWrapClassName, {
			width: "58px",
			height: "58px",
			borderTopLeftRadius: "50%"
		}, { width: "100%" });
	}
	const iconBarPositionClassName01 = info.iconElemWrap?.parentElement?.classList[0];
	if (iconBarPositionClassName01) {
		modifyCSSRuleMultiple(info.shadowRoot, iconBarPositionClassName01, {
			position: "absolute",
			marginLeft: "-29px"
		}, {
			position: "unset",
			marginLeft: "unset"
		});
	}
	const iconBarPositionClassName02 = info.iconElemWrap?.parentElement?.parentElement?.classList[0];
	if (iconBarPositionClassName02) {
		// bt633
		modifyCSSRuleMultiple(info.shadowRoot, iconBarPositionClassName02, {
			width: "320px",
			bottom: "0px"
		}, { bottom: "40px" });
	}
	const iconClassName = info.iconElem.classList[0];
	if (iconClassName) {
		modifyCSSRuleMultiple(info.shadowRoot, iconClassName, {
			width: "58px",
			height: "58px",
			cursor: "pointer",
			justifyContent: "center"
		}, {
			width: "100%",
			borderRadius: "unset",
			justifyContent: "left",
			padding: "0 16px",
			borderTopLeftRadius: "6px",
			borderTopRightRadius: "6px",
			borderBottomLeftRadius: "0px",
			borderBottomRightRadius: "0px"
		});
	}
	// set total elem
	const totalClassName = info.totalElem.classList[info.totalElem.classList.length - 1];
	if (totalClassName) {
		modifyCSSRuleMultiple(info.shadowRoot, totalClassName, {
			top: "-2px",
			left: "40px",
			position: "absolute"
		}, {
			top: "unset",
			left: "unset",
			position: "relative"
		});
	}
}), tap(([lang, info]) => {
	// hide icon svg
	if (info.iconSvgElem) {
		info.iconSvgElem.style.display = "none";
	}
	// add wording (betslip)
	if (info.iconSvgElem) {
		const span = document.createElement("span");
		span.textContent = `${$t(Verbiage.fomo_betby_betslip)}`;
		span.style.marginLeft = "8px";
		span.style.fontSize = "16px";
		span.style.marginRight = "4px";
		span.style.fontWeight = "600";
		span.style.letterSpacing = lang === "ja" ? "-3px" : "unset";
		info.iconSvgElem.after(span);
	}
	// add up arrow
	if (info.totalElem) {
		const svgElement = document.createElement("span");
		svgElement.style.marginLeft = "auto";
		const svgNS = "http://www.w3.org/2000/svg";
		const svg = document.createElementNS(svgNS, "svg");
		svg.setAttribute("width", "16");
		svg.setAttribute("height", "16");
		svg.setAttribute("fill", "currentColor");
		svg.setAttribute("class", "bi bi-chevron-up");
		svg.setAttribute("viewBox", "0 0 16 16");
		const path = document.createElementNS(svgNS, "path");
		path.setAttribute("fill-rule", "evenodd");
		path.setAttribute("d", "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z");
		svg.appendChild(path);
		svgElement.appendChild(svg);
		info.totalElem.after(svgElement);
	}
})).subscribe();
onMount(() => {
	console.log(`betby componentmounted`);
	updateBetbyMobileTop();
	const onResize = () => updateBetbyMobileTop();
	window.addEventListener("resize", onResize);
	window.addEventListener("popstate", onPopState);
	if (isSportsUrl(get(page).url.pathname)) {
		isBetbyDisplayed.set(true);
	}
	return async () => {
		console.log(`betby component destroyed`);
		isBetbyDisplayed.set(false);
		betslipStateSub.unsubscribe();
		betslipBarCustomizeSub.unsubscribe();
		setIsCollapsedFomoBets(false);
		window.removeEventListener("resize", onResize);
		window.removeEventListener("popstate", onPopState);
		await killSession();
	};
});
</script>

<div id="betby" bind:this={betbyContainer}>
	<!-- <Loading /> -->
	<div class="betby-content" id="betby-content"></div>
	<SportsSeoText />
	<Footer />
</div>

<style>
	#betby {
		z-index: 990;
		width: 100%;
		min-width: 0px;
		max-width: 100%;
		flex: 1 1 0%;
		--tw-bg-opacity: 1;
		background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
		position: relative;
		top: var(--betby-mobile-top, 72px);
		min-height: calc(
			var(--app-vh, 100vh) - 72px - env(safe-area-inset-top) - env(safe-area-inset-bottom, 0px) -
				60px
		);
		overscroll-behavior: none;
}
	@media (min-width: 1024px) {
		#betby {
			top: 0;
			/*
			 * Keep one full desktop viewport for sports content so the footer
			 * stays below the fold and appears only after scrolling.
			 */
			min-height: calc(
				var(--app-vh, 100vh) - 72px - env(safe-area-inset-top) - env(safe-area-inset-bottom, 0px)
			);
			min-height: calc(100dvh - 72px - env(safe-area-inset-top) - env(safe-area-inset-bottom, 0px));
		}
	}
	.opacity1 {
		opacity: 1;
}
	.opacity0 {
		opacity: 0;
}
	.betby-content {
		min-height: calc(
			var(--app-vh, 100vh) - 72px - env(safe-area-inset-top) - env(safe-area-inset-bottom, 0px)
		);
		overscroll-behavior: none;
	}
</style>
